import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorLabel } from '../../../components/ErrorLabel';
import { FileList } from './FileList';
import { UploadFile } from './appendixUpload/UploadFile';

const AppendixUpload = ({
  onUploadFiles,
  fileItems,
  onDeleteFile,
  onDownloadFile,
  maxFileSize,
  allowMultiple,
  headerText,
  allowedFileTypes,
  setIsHearingAnswered,
}) => {
  const { t: translator } = useTranslation();

  const [showError, setShowError] = useState(false);

  const onUploadFilesLocal = (event) => {
    const files = [...event.target.files]; // Convert from FileList --> array
    const validatedFiles = files.filter(
      (file) => file.size !== 0 && file.size <= maxFileSize,
    );

    if (validatedFiles.length !== files.length) {
      setShowError(true);
    } else {
      setShowError(false);
    }
    onUploadFiles({
      target: {
        files: validatedFiles,
      },
    });

    if (setIsHearingAnswered) {
      setIsHearingAnswered(true);
    }
  };

  return (
    <div>
      <div className="create-hearing-form-field">
        <p>{translator('components.fileComponents.uploadFile')}</p>
        <UploadFile
          onUploadFiles={onUploadFilesLocal}
          maxFileSize={maxFileSize}
          allowMultiple={allowMultiple}
          allowedFileTypes={allowedFileTypes}
        />
      </div>
      {showError && (
        <ErrorLabel>
          {translator('components.fileComponents.uploadFileError')}
        </ErrorLabel>
      )}
      <div className="create-hearing-form-field">
        <FileList
          onDownloadFile={onDownloadFile}
          onDeleteFile={onDeleteFile}
          items={fileItems}
          headerText={headerText}
        />
      </div>
    </div>
  );
};

export { AppendixUpload };
